import { render, staticRenderFns } from "./FoliosBranchReport.vue?vue&type=template&id=0244935a&"
import script from "./FoliosBranchReport.vue?vue&type=script&lang=js&"
export * from "./FoliosBranchReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports